export const featurePaths = {
    ARTransactionsList: "/ARTransactionsList",
    CreateARInvoice: "/ARTransactionsList/CreateARInvoice",
    ARCreditNote: "/ARTransactionsList/ARCreditNote",
    APTransactionsList: "/APTransactionsList",
    CreateAPInvoice: "/APTransactionsList/CreateAPInvoice",
    APCreditNote: "/APTransactionsList/APCreditNote",
    ArInvoiceExtractList:"/ArInvoiceExtractList",
    APARAccuralExtractList:"/APARAccuralExtractList",
    PLReport:"/PLReport",
    MdgList: "/MdgList",
    MdgView:"/MdgList/MdgView",
    SpecificationReport:"/SpecificationReport",
    ARApprovedsapdirectextract:"/ARApprovedsapdirectextract",
    InvoiceDocumentUpload:"/InvoiceDocumentUpload",
    ARInvoiceRpt:"/ARInvoiceRpt",
    SupplierInvoicesRpt:"/SupplierInvoicesRpt",
    WIPSalesRpt:"/WIPSalesRpt",
    CostAaccrualrpt:"/CostAaccrualrpt",
} as const;

export const apiPaths = {} as const;
